import { Mail, Clock } from "lucide-react";
import { useDocumentHead } from "@/hooks/useDocumentHead.ts";

export function ContactPage() {
  useDocumentHead({
    title: "Contact Us",
    description: "Get in touch with The Secret Trends. Questions about products, brand partnerships, or general inquiries — we're here to help.",
  });

  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <h1 className="text-3xl font-bold text-gray-900">Contact Us</h1>

      <div className="mt-8 space-y-6 text-gray-600 leading-relaxed">
        <p>
          Have questions about a product, interested in a brand partnership, or just
          want to say hello? We'd love to hear from you!
        </p>

        <div className="rounded-xl border border-gray-200 bg-white p-6 space-y-4">
          <div className="flex items-center gap-3">
            <Mail className="h-5 w-5 text-indigo-600" />
            <div>
              <p className="text-sm font-medium text-gray-900">Email</p>
              <a
                href="mailto:info@thesecrettrends.com"
                className="text-indigo-600 hover:underline"
              >
                info@thesecrettrends.com
              </a>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <Clock className="h-5 w-5 text-indigo-600" />
            <div>
              <p className="text-sm font-medium text-gray-900">Business Hours</p>
              <p className="text-sm text-gray-500">
                Monday &ndash; Friday, 8:00 AM to 6:00 PM CST
              </p>
            </div>
          </div>
        </div>

        <p>
          We typically respond to all inquiries within 24 hours during business
          days.
        </p>
      </div>
    </div>
  );
}
